import { render, staticRenderFns } from "./DownloadResults.vue?vue&type=template&id=68f6fc55&scoped=true&"
import script from "./DownloadResults.vue?vue&type=script&lang=js&"
export * from "./DownloadResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f6fc55",
  null
  
)

export default component.exports